import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type Action = {
  id: 'connectTv' | 'changeContent' | 'schedule' | 'upload';
  to: string;
  icon: ReactNode;
};

/** Jobs that are not already bottom tabs. */
const ACTIONS: Action[] = [
  {
    id: 'connectTv',
    to: '/screens#setup',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M9 20h6M12 16v4" />
      </svg>
    ),
  },
  {
    id: 'changeContent',
    to: '/screens',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
        <circle cx="9" cy="9" r="1.6" />
        <path d="m20 15-4.5-4.5L6 20" />
        <path d="M16 8h4M18 6v4" />
      </svg>
    ),
  },
  {
    id: 'schedule',
    to: '/schedule',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
        <rect x="3.5" y="5" width="17" height="15" rx="2" />
        <path d="M3.5 10h17M8 3v4M16 3v4" />
      </svg>
    ),
  },
  {
    id: 'upload',
    to: '/content#upload',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
        <path d="M12 16V5" />
        <path d="m8 9 4-4 4 4" />
        <path d="M4 19h16" />
      </svg>
    ),
  },
];

export function HomeMobileQuickActions() {
  const { t } = useTranslation('home');
  return (
    <section className="flex flex-col gap-2.5">
      <h2 className="m-0 text-[13px] font-bold uppercase tracking-[0.12em]" style={{ color: 'var(--gs-muted)' }}>
        {t('mobile.quickActions.title')}
      </h2>
      <div className="grid grid-cols-2 gap-2.5">
        {ACTIONS.map((action) => (
          <Link
            key={action.id}
            to={action.to}
            className="flex min-h-[88px] flex-col justify-between rounded-[14px] border p-3.5 no-underline transition hover:border-[var(--gs-accent)]"
            style={{
              background: 'var(--gs-panel)',
              borderColor: 'var(--gs-line)',
              color: 'var(--gs-ink)',
            }}
          >
            <span style={{ color: 'var(--gs-muted)' }} aria-hidden>
              {action.icon}
            </span>
            <span className="text-[14px] font-bold leading-tight">
              {t(`mobile.quickActions.${action.id}`)}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
